import { useParams } from "react-router-dom";
import PageSEO from "@/components/PageSEO";

const CONTENT = {
  terms: {
    title: "Terms & Conditions",
    body: [
      "These Terms & Conditions govern your use of the Mayoto website and services. By accessing Mayoto, you agree to these terms.",
      "Mayoto is a Nigerian investment company that creates structured investment opportunities. Nothing on this website constitutes financial advice.",
      "All content, branding and materials on this website are the property of Mayoto and may not be reproduced without written permission.",
      "Mayoto reserves the right to update these terms from time to time. Continued use of the platform constitutes acceptance of updated terms.",
      "For questions, please contact us at mayotonexo@gmail.com.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "Mayoto respects your privacy and is committed to protecting the personal information you share with us.",
      "We collect only the information necessary to provide our services — including your name, email, phone number, address, date of birth and identification information for KYC purposes.",
      "We do not sell your data. We use secure infrastructure and industry-standard practices to safeguard your information.",
      "You may request access to, or deletion of, your data at any time by contacting mayotonexo@gmail.com.",
      "By using Mayoto, you consent to the processing of your personal information as described in this policy.",
    ],
  },
  risk: {
    title: "Investment Risk Disclosure",
    body: [
      "All investments carry risk. Past performance is not a reliable indicator of future results.",
      "Investment returns are not guaranteed. Mayoto opportunities are structured with clear terms and risk information — please read every opportunity's specific risk disclosure before committing capital.",
      "Real estate carries liquidity, market timing and regulatory risk. Agricultural projects carry weather, biological and market pricing risk. Business investments carry execution, competition and market risk.",
      "You should only invest what you can afford to lose, and consider diversifying across sectors and opportunities.",
      "Mayoto is not a bank, is not deposit-taking, and does not offer risk-free products. Nothing on this site constitutes financial or investment advice.",
    ],
  },
  "investment-terms": {
    title: "Investment Terms",
    body: [
      "Each Mayoto investment opportunity is governed by opportunity-specific terms published on its opportunity page.",
      "These terms outline the return structure, duration, closing date, exit mechanism, reporting cadence and specific risks associated with the underlying project.",
      "By committing capital to any opportunity, you accept the specific investment terms of that opportunity and this general framework.",
      "Mayoto acts as the arranger and administrator of the opportunity. Where applicable, opportunities may be structured via Special Purpose Vehicles or Trustee arrangements to protect investor interests.",
      "For detailed investment memoranda on any specific opportunity, please contact Mayoto.",
    ],
  },
};

export default function Legal() {
  const { kind } = useParams();
  const c = CONTENT[kind] || CONTENT.terms;

  const seoDescMap = {
    terms: "The terms and conditions governing use of Mayoto's website, investor account and structured investment services.",
    privacy: "How Mayoto collects, uses and protects the personal information you share with us.",
    risk: "Investment risk disclosure — every Mayoto opportunity carries risk. Read our sector-specific risk information.",
    "investment-terms": "Mayoto structured investment terms — how opportunities are arranged, administered and settled.",
  };

  return (
    <div>
      <PageSEO
        title={c.title}
        description={seoDescMap[kind] || `Read Mayoto's ${c.title.toLowerCase()}.`}
        canonicalPath={`/legal/${kind || "terms"}`}
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 max-w-4xl">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">LEGAL</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128]" data-testid={`legal-${kind}-title`}>{c.title}</h1>
          <p className="mt-3 text-sm text-slate-500">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>
      <section className="py-12 bg-white">
        <div className="container-wide max-w-3xl">
          <div className="prose prose-slate max-w-none">
            {c.body.map((p, i) => <p key={i} className="text-slate-700 leading-relaxed text-base mb-5">{p}</p>)}
          </div>
        </div>
      </section>
    </div>
  );
}
